import React from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { useNavigate } from 'react-router-dom';
import './privacy.css';

const privacyData = [
  {
    "title": "Privacy Control",
    "description": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
  }
]

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <div className='myRatesMain'>
      {Object.keys(privacyData).map(keyName => {
        const privacy = privacyData[keyName];
        return (
          <>
            <div className='privacyMainHeading'>
              <div onClick={() => navigate(-1)}>
                <ArrowCircleLeftOutlinedIcon className='headingIcon' fontSize='large' />
              </div>
              <h3>{privacy.title}</h3>
            </div>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  ml: 2,
                  mr: 2,
                  pl: 2,
                  pr: 2,
                  pb: 3,
                  width: "100%",
                  height: "auto",
                },
              }}
            >
              <Paper elevation={1} pl={5}>
                <p className='privacy-content'>{privacy.description}</p>
              </Paper>
            </Box>
          </>
        )
      })}
    </div>
  )
}
export default Privacy;
